module.exports = __webpack_public_path__ + "img/ClickForSound_9.25709157.png";